<template>

  <button
    type="button"
    class="dropdown-item"
    @click="requalify">
    <i class="fas fa-star" /> {{ $t('Mark as new') }}
    </button>

</template>

<script>
export default {
  name: 'JobActionMassRenew',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    }
  },
  created () {
  },
  methods: {
    /*
    requalify
    */
    requalify () {
      this.candidates.forEach((candidate) => {
        const placement = candidate.placements.find(v => v.job_id === this.job._id)
        this.$store.dispatch('updatePlacement', {
          _id: placement._id,
          new: true
        })
      })

      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionRenew.vue